module.exports = __webpack_public_path__ + "icon-128-visualisation-pie.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-pie.png
// module id = 631
// module chunks = 11